// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-menu {
  width: 100%;
}

.mobile-menu__title {
  padding: 10px 20px;
  display: flex;
  gap: 4px;
}

.mobile-menu__logo {
  width: 100px;
  display: block;
}

.mobile-menu__logo img {
  width: 100%;
}

.mobile-menu__close-button {
  background: unset;
  padding: unset;
}

.mobile-menu__list {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-inline: 20px;
  margin-top: 36px;
}

.mobile-menu__list li a {
  color: #323232;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 12px;
}

.mobile-menu__active {
  border-left: 2px solid #FF0009;
}
`, "",{"version":3,"sources":["webpack://./src/components/mobile-menu/MobileMenu.scss","webpack://./src/components/mobile-menu/MobileMenu.css"],"names":[],"mappings":"AAAA;EACE,WAAW;ACCb;;ADCE;EACE,kBAAkB;EAGnB,aAAA;ECED,QAAQ;ADAR;;ACGF;EDIG,YAAA;ECFD,cAAc;ADLb;;ACQH;EACE,WAAW;ADAX;;ACGF;EDAG,iBAAA;ECED,cAAc;ADAd;;ACGF;EDEI,aAAY;EAID,sBAAO;EACd,SAAS;EACT,oBAAkB;EAClB,gBAAgB;ACExB;;AAEA;EACE,cAAc;EDEd,eAAA;EACE,kBAAa;EACd,gBAAA;ECAD,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".mobile-menu {\n  width: 100%;\n\n  &__title {\n    padding: 10px 20px;\n    display: flex;\n    gap: 4px;\n  }\n\n  &__logo {\n    width: 100px;\n    display: block;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  &__close-button {\n    background: unset;\n    padding: unset;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding-inline: 20px;\n    margin-top: 36px;\n\n    li {\n      a {\n        color: #323232;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        padding: 6px 12px;\n      }\n    }\n  }\n\n  &__active {\n    border-left: 2px solid #FF0009;\n  }\n}",".mobile-menu {\n  width: 100%;\n}\n\n.mobile-menu__title {\n  padding: 10px 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 4px;\n}\n\n.mobile-menu__logo {\n  width: 100px;\n  display: block;\n}\n\n.mobile-menu__logo img {\n  width: 100%;\n}\n\n.mobile-menu__close-button {\n  background: unset;\n  padding: unset;\n}\n\n.mobile-menu__list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 24px;\n  padding-inline: 20px;\n  margin-top: 36px;\n}\n\n.mobile-menu__list li a {\n  color: #323232;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  padding: 6px 12px;\n}\n\n.mobile-menu__active {\n  border-left: 2px solid #FF0009;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
